import StorageService from "./StorageService.js";
import {history} from '../constants/history';
const axios = require('axios');
const baseUrl = process.env.REACT_APP_BASE_URL;
const headerAuthorization = 'Authorization';

export class ApiResponseError extends Error {
    constructor(err) {
        super(err.message);
        super.name = "ApiErrResponseError";
        this.response = err.response;
        this.responseError = err.response.data.error;
    }
}

export class ApiService {

    static getAbsoluteURL(endpoint) {
        return baseUrl + endpoint;
    }

    static async postWithNoAuth(endpoint, request) {
        return await this.sendNoAuthRequest('POST', endpoint, request);
    }

    static async postOAuth(endpoint, request) {
        return await this.sendOAuthRequest('POST', endpoint, request);
    }

    static async post(endpoint, request) {
        const response = await this.sendRequest('POST', endpoint, request);
        return response.data;
    }

    static async get(endpoint) {
        const response = await this.sendRequest('GET', endpoint, null);
        return response.data;
    }


    static async delete(endpoint) {
        let request = {}
        return await this.sendRequest('DELETE', endpoint, request);
    }


    static async sendRequest(method, endpoint, body) {
        return await this._sendRequest(method, endpoint, body, true);
    }

    static async sendNoAuthRequest(method, endpoint, body) {
        return await this._sendRequest(method, endpoint, body, false);
    }

    static async sendOAuthRequest(method, endpoint, body) {
        const url = this.getAbsoluteURL(endpoint);
        let payload = "";
        let headers = {
            "Accept": "application/json",
            "Content-Type": "application/x-www-form-urlencoded",
            "Authorization": "Basic RGFzaGJvYXJkOmRhc2hib2FyZA=="
        };

        let request = {
            url: url,
            method: method,
            headers: headers,
            data: body
        };
        return await this.axiosRequest(payload, request);
    }

    static async _sendRequest(method, endpoint, body, useAuth) {
        const url = this.getAbsoluteURL(endpoint);
        let payload = "";
        let headers = {
            "Accept": "application/json",
            "Content-Type": "application/json"
        };

        if (useAuth) {
            headers[headerAuthorization] = await StorageService.getAccessToken();
        }

        let request = {};

        if (body) {
            request = {
                url: url,
                method: method,
                headers: headers,
                data: body
            };
        } else {
            request = {
                url: url,
                method: method,
                headers: headers,
            };
        }

        // Handled 401 error with redirection to login
        try{
            const response = await this.axiosRequest(payload, request);
            return response;
        }catch (err) {
            if(err.response && err.response.status == 401){   
                history.push({
                  pathname: '/login',
                  state: { isPropsAuthenticated: false }
                });
            }else{
                throw err;
            }
        }
    }

    static async axiosRequest(payload, request) {
        try {
            payload = await axios(request);
        } catch (err) {
            if (err.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.error(err);
                throw new ApiResponseError(err);
            } else if (err.request) {
                // The request was made but no response was received
                // Do something meaningful !!
                console.error(err);
                throw err;
            } else {
                // Something happened in setting up the request that triggered an Error
                // Ideally, this should not happen !
                console.error(err);
                throw err;
            }

        }
        return payload;
    }
}